import React from "react";
import styles from "./SubHeader.scss";
import { getLocalizedStrings } from "../../centralizedLocalizedString";
let CAN;

class SubHeader extends React.Component {
  constructor(props) {
    super(props);
    
  }
  render() {
    let details = this.props.contractResult;
    let strings = getLocalizedStrings("AccountPreference");
    // alert(JSON.stringify(details));
    CAN = details.contractNumber;
    let streetAddress=details.streetAddress ? details.streetAddress.toLowerCase() : null;
    let city=details.city ? details.city.toLowerCase() : null;
    let unitNumber = !_.isEmpty(details.unitNumber) ? details.unitNumber+", ": "" ;
    let streetAdd=streetAddress.split(' ');
    let cityAdd=city.split(' ');
    

    function capitalizeFirstLetter(str){
      let n=str.length;
      let s="";
      for(let i=0;i<n;i++){
        if(i<n-1){
        s=s+str[i].charAt(0).toUpperCase()+str[i].substring(1,str[i].length)+" ";
        }
        else{
          s=s+str[i].charAt(0).toUpperCase()+str[i].substring(1,str[i].length);
        }
      }
      return s;
    }
  streetAddress=capitalizeFirstLetter(streetAdd);
  city=capitalizeFirstLetter(cityAdd);


    let arrow =(
        <div className={styles.Arrow} >       
          {this.props.isContractResultExpanded && (details.contractNumber === this.props.contractNumber)? (
            <img  src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/icon_chevron_black.svg'} alt="up arrow" /> 
          ) : (
            <img className={styles.downArrow} src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/icon_chevron_black.svg'} alt="down arrow" /> 
          )}
        </div>
      );
    return (
      <div>
      <button  className={styles.buttonTag} onClick={() => this.props.onContractResultClick(this.props.accountData.contractAccountNumber, details.contractNumber, details.premiseNumber,this.props.isContractResultExpanded && (details.contractNumber === this.props.contractNumber), this.props.accountData.bpNumber, this.props.accountData.bpCategory)} >
      <div className={styles.AccountDetails} >
        <div className={styles.AccountDetailsContent}>
          <div className={styles.AccountDetailsText}>
          <div
            className={styles.AccountAddress}
            title={
              details.houseNumber +
              " " +
              streetAddress +
              ", " +
              unitNumber+
              city +
              ", " +
              details.state +
              " " +
              details.zipcode
            }
          >
            {details.houseNumber}
            {" "}
            {streetAddress}{", "}{unitNumber}{city}{", "}{details.state}{" "}
            {details.zipcode}
          </div>
            <div className={styles.AccountNumber}>
              {" "} &nbsp;
              {strings.Acct} {CAN}
            </div>
          
          </div>
          {arrow}
          
        </div>
          {/* {this.props.isContractAccountExpanded ? <h1 style={{background:'black'}}>ddd</h1> : null} */}
      </div>
      </button>
      </div>
    );
  }
}
export default SubHeader;
